import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { Heading } from '@chakra-ui/react';

/**
 * Heading - h5
 *
 * @see Docs https://chakra-ui.com/heading
 */
var HeadingH5 = function HeadingH5(props) {
  return /*#__PURE__*/React__default.createElement(Heading, _extends({
    as: "h5",
    size: "h5"
  }, props));
};
export { HeadingH5 };